module.exports = __webpack_public_path__ + "70d68ebec0f29f0d49f505a91285eedd.jpg";